<template>
  <v-container grid-list-xl notificationHistory>
    <v-layout row wrap>
      <v-flex lg12>
        <h2  v-if="notificationHistoryLoaded == false" style="padding-top: 10%;"><center>Loading History<br /><span style="font-size: 12px;">Please Wait</span></center></h2>
      </v-flex>
      <v-data-table v-if="notificationHistoryLoaded == true" :search="search" :headers="headers" :items="notificationHistory" expand hide-actions>
        <template slot="items" slot-scope="props">
          <tr>
            <td width="5%">{{ fncCheckType(props.item.type) }}</td>
            <td width="15%">{{ props.item.entity }}</td>
            <td width="25%">{{ props.item.entity_subject }}</td>
            <td width="40%" v-html="fncSetAttachments( props.item.filename )"></td>
            <td width="5%">{{ fncCheckBool(props.item.sent) }}</td>
            <td width="10%">{{ fncCheckdate(props.item.send_date) }}</td>
          </tr>
        </template>
      </v-data-table>
      <div class="pl-4 pr-1 pb-4 buttonHolder">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
          headers: [
            { text: 'Type', value: 'type', width: '5%' },
            { text: 'Email / Number', value: 'entity', width: '15%' },
            { text: 'Subject', value: 'sent', width: '25%' },
            { text: 'Attachments', value: 'sent', width: '40%' },
            { text: 'Sent', value: 'sent', width: '5%' },
            { text: 'Send Date', value: 'send_date', width: '10%' }
          ],
			};
		},
      methods: {
        fncHideModal () {
          this.$store.commit('hideModal');
        },
        fncCheckBool( varBool ) {
          if( varBool == 1 || varBool == true ) {
            return 'Yes';
          } else {
            return 'No';
          }
        },
        fncCheckdate( varDate ) {
          if( varDate == '' || varDate == '0' || varDate == null ) {
            return 'N/A';
          } else {

            var options = {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "numeric",
              minute: "numeric",
              hour12: false
            };

            var newDate = new Date( Date.parse(varDate + ' UTC') );
            var dateString = newDate.toLocaleString("en", options);
            var objDate = dateString.split(',');

            var newDate = objDate[0].split('/');

            var strDate = newDate[2] + '-' + newDate[0] + '-' + newDate[1] + ' ' + objDate[1];

            return strDate;
            // return varDate;
          }
        },
        fncCheckType( varType ) {
          if( varType == 'email' ) {
            return 'Email';
          } else {
            return 'Whatsapp';
          }
        },
        fncSetAttachments( filename ) {

          if( filename != '' ) {
              return filename
              .split("|||")
              .map(url => `<a href="${url}" target="_blank">${url}</a>`)
              .join("<br />");
          }
           
          return 'None';

        }
		},
    beforeMount() {

      this.$store.dispatch({
        type: 'fncNotificationHistory',
        quoteId: this.globalModalParams.quote
      });

    },
    computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'objUserInfo',
        'notificationHistory',
        'notificationHistoryLoaded',
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
